module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/vehicles/vehicle-list/vehicle-list.component.css
// module id = ./src/app/components/vehicles/vehicle-list/vehicle-list.component.css
// module chunks = main